module.exports = require("ramda/src/equals");